export { ReactComponent as HomeIcon } from "assets/home.svg";
// export { ReactComponent as PauseIcon } from "assets/home/pause.svg";
// export { ReactComponent as PlayIcon } from "assets/home/play.svg";
export { ReactComponent as SoundOnIcon } from "assets/home/soundon.svg";
export { ReactComponent as SoundOffIcon } from "assets/home/soundoff.svg";
export { ReactComponent as BvlgariIcon } from "assets/Bvlgari.svg";
export { ReactComponent as ShareIcon } from "assets/share.svg";
export { ReactComponent as ZoomIcon } from "assets/zoom.svg";

export { default as InvitationConfrimWordingTopImg } from "assets/invitation/invitation_confirm_wording_top.png";
export { default as InvitationConfrimWordingBottomImg } from "assets/invitation/invitation_confirm_wording_bottom.png";
export { default as HeadphoneIcon } from "assets/customer-service.png";
export { default as HomeImgIcon } from "assets/home.png";
export { default as ShareImgIcon } from "assets/share.png";

export const BgImg =
  "https://d5j80r6ig58b5.cloudfront.net/img/79/s00079-cfa76ff3-0160-4eea-838a-239035bf38e0";
export const bookBgImg =
  "https://d5j80r6ig58b5.cloudfront.net/img/79/s00079-fc65fc13-4417-4cc3-b03a-b1fdaacdbcec";
export const bookPreviewVideo =
  "https://d5j80r6ig58b5.cloudfront.net/img/79/s00079-49384327-0c4c-47df-8a39-662f375cb452";
export const homeCarousel1Img =
  "https://d5j80r6ig58b5.cloudfront.net/img/79/s00079-794f9b6b-3c83-4571-8da1-4fb9ed927143";
export const homeCarousel2Img =
  "https://d5j80r6ig58b5.cloudfront.net/img/79/s00079-df2f11bd-1c0f-4976-9b1a-f40912a51963";
export const homeCarousel3Img =
  "https://d5j80r6ig58b5.cloudfront.net/img/79/s00079-909ff953-6b6d-4d82-9888-e9a4e8683cdf";
export const homeCarousel4Img =
  "https://d5j80r6ig58b5.cloudfront.net/img/79/s00079-95ddc6b5-40f6-410d-aa96-0c352ebe7fdc";
export const homePreviewVideo =
  "https://d5j80r6ig58b5.cloudfront.net/img/s00080-43c8017c-9361-4e1d-8e5d-d1749958ff47";
export const watchImg =
  "https://d5j80r6ig58b5.cloudfront.net/img/79/s00079-40eb04d5-4dcc-4f8e-ac43-d4007d3b5938";

export const flexBGImageUri =
  "https://d5j80r6ig58b5.cloudfront.net/img/s00079-f4836355-f571-466e-8cbf-dc20814d2c6d";
export const flexLogoImageUri =
  "https://d5j80r6ig58b5.cloudfront.net/img/s00079-5ca86e60-377b-4fb5-8a58-8f86a28747fb";
export const flexActivityBGImageUri =
  "https://d5j80r6ig58b5.cloudfront.net/img/s00079-0786b34b-66f3-4d80-a56e-46d4ece54f36";
export const flexInvitationImg =
  "https://d5j80r6ig58b5.cloudfront.net/img/s00080-c3df8b96-235f-4b7f-9b98-01103bf83201";
export const flexActivityBottomImgUri =
  "https://d5j80r6ig58b5.cloudfront.net/img/79/s00079-c8db9a10-7d03-4193-b50c-c28cdab90327";

export const shopId = window.SHOP_ID || process.env.REACT_APP_SHOP_ID;
export const scheduleEventId = Number(
  window.SCHEDULE_EVENT_ID || process.env.REACT_APP_SCHEDULE_EVENT_ID
);
export const shop = window.SHOP || {};
export const apiHost =
  window.API_HOST || process.env.REACT_APP_API_HOST || window.location.origin;
export const baseUrl = window.BASEURL || process.env.REACT_APP_BASEURL || "";
export const baseRoute =
  window.BASE_ROUTE || process.env.REACT_APP_BASE_ROUTE || "";
export const liffId = window.LIFF_ID || process.env.REACT_APP_LIFF_ID;
export const lineOAUrl =
  window.LINE_AT_URL || process.env.REACT_APP_LINE_URL || "";
export const GA_trackId =
  window.TRACKING_ID || process.env.REACT_APP_TRACKING_ID || "";
export const stage = process.env.REACT_APP_ENV || "";

export const GA_UTM_SOURCE = "utm_source";
export const GA_UTM_MEDIUM = "utm_medium";
export const GA_UTM_CAMPAIGN = "utm_campaign";
export const GA_IP = "ip";
export const GA_UUID = "uuid";

export const Annotation = {
  Type: {
    INPUT: "INPUT",
    ITEM_LIST: "ITEM_LIST",
    DATE: "DATE",
    OPTIONS: "OPTIONS",
    ORDERER: "ORDERER",
    BRANCH: "BRANCH",
    STORE_SEVEN: "STORE_SEVEN",
    STORE_FAMILY: "STORE_FAMILY",
    COUPON: "COUPON",
    POINT: "POINT",
  },

  SystemKey: {
    PAYMENT: "payment",
    DELIVERY: "delivery",
    COUPON: "coupon",
    POINT: "point",
    ACCOUNT: "account",
    INSTALLMENT_MONTH: "installment_month",
    BRANCH: "branch",
    ADDRESS: "address",
    STORE_FAMILY: "store_family",
    STORE_SEVEN: "store_seven",
  },

  DateMode: {
    DATETIME: "DATETIME",
    TIME: "TIME",
    DATE: "DATE",
    LUNAR: "LUNAR",
  },
};

export const DATEPARSE = {
  0: "日",
  1: "一",
  2: "二",
  3: "三",
  4: "四",
  5: "五",
  6: "六",
};
